/* eslint-disable */
import { List, ListItem, Typography } from '@mui/material';
import { Modal } from './Modal';
import type { ReactElement } from 'react';

interface IRichModalProps {
  open: boolean;
  title?: string;
  width?: string;
  subtitle?: string;
  cancelButtonText?: string;
  buttonText?: string;
  hideFooter?: boolean;
  children?: ReactElement | ReactElement[];
  footer?: ReactElement;
  hideCancel?: boolean;
  hideSave?: boolean;
  isLoading?: boolean;
  onConfirm?(): void;
  onClose?(event: object, reason?:string): void;
  draggable?: boolean;
  hideBackdrop?: boolean;
}

interface IAlertMessage {
  subtitle: string;
  listItem: string[];
}

interface IAlertModalProps extends IRichModalProps {
  title: string;
  open: boolean;
  minWidth?: string;
  maxWidth?: string;
  subtitle?: string;
  alertMessages?: IAlertMessage[]; 
  buttonText?: string;
  textSize?: string;
  marginTop?: number;
  onConfirm?: () => void;
  onClose?: (event: object, reason?:string) => void;
  isLoading?: boolean;
}

export const AlertModal = ({
  subtitle,
  textSize,
  marginTop = 1,
  alertMessages,
  isLoading,
  open,
  onConfirm,
  minWidth = '100px',
  maxWidth = '500px',
  ...props
}: IAlertModalProps) => {

  return (
    <Modal showFooter dialogMinWidth={minWidth} dialogMaxWidth={maxWidth} isSubmitting={isLoading} open={open} onConfirm={onConfirm} onClose={props.onClose} {...props}>
      {(alertMessages || []).map((alertMessage, index) => (
        <>
          <Typography key={index} sx={{ mt: marginTop, fontSize: textSize }}>
            {alertMessage.subtitle}
          </Typography>
          {alertMessage.listItem && (
            <div>
              <List sx={{ listStyleType: 'disc', pl: 2, padding: 0 }}>
                {alertMessage.listItem.map((item: string) => (
                  <ListItem key={item} sx={{ display: 'list-item' }}>
                    {item}
                  </ListItem>
                ))}
              </List>
            </div>
          )}
        </>
      ))}
      {subtitle && (
        <Typography
          sx={{ mt: marginTop, fontSize: textSize }}
          dangerouslySetInnerHTML={{ __html: subtitle }}
        />
      )}
    </Modal>
  );
};
